export const makeMainName = (product_color) => {
  return product_color['name' + G._en] || product_color.name;
};
